import { render } from "./Cooperative.vue?vue&type=template&id=1647cb80&scoped=true"
import script from "./Cooperative.vue?vue&type=script&lang=js"
export * from "./Cooperative.vue?vue&type=script&lang=js"

import "./Cooperative.vue?vue&type=style&index=0&id=1647cb80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1647cb80"]])

export default __exports__